import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authenticated: false, // Authenticated with Okta
    fbAuthenticated: false // Authenticated with Firebase
  },
  actions: {
    setupTooltips () {
      console.log('Setting up tooltips.')
      const tooltips = document.getElementsByClassName('tooltip')
      document.addEventListener('click', (e) => {
        if (!e.target.classList.contains('tooltip')) {
          tooltips.forEach((tooltip) => {
            tooltip.classList.remove('clicked')
          })
        }
      })
      tooltips.forEach((tooltip) => {
        tooltip.addEventListener('click', () => {
          tooltip.classList.toggle('clicked')
        })
      })
    }
  },
  mutations: {
    setAuthenticated (state, val) {
      state.authenticated = val
    },
    setFbAuthenticated (state, val) {
      state.fbAuthenticated = val
    }
  }
})
